import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-delete-item-notification-dialog',
  templateUrl: './delete-item-notification-dialog.component.html',
  styleUrls: ['./delete-item-notification-dialog.component.scss']
})
export class DeleteItemNotificationDialogComponent {
  @Input() notificationId: number | undefined
  @Output() deleteItemNotification: EventEmitter<number> = new EventEmitter<number>()

  constructor(
    private modalService: ModalService
  ) {
  }

  deletePaylink() {
    this.deleteItemNotification.emit(this.notificationId)
  }

  closeModal() {
    this.modalService.closeModal()
  }
}
